import { CameraIcon, RulerIcon } from './Icons';

export type AnalyzerMode = 'photo' | 'manual';

interface AnalyzerTabsProps {
  mode: AnalyzerMode;
  onChange: (mode: AnalyzerMode) => void;
}

export function AnalyzerTabs({ mode, onChange }: AnalyzerTabsProps): React.ReactElement {
  return (
    <div className="analyzer-tabs" role="tablist" aria-label="Choose an analysis method">
      <button
        id="photo-tab"
        className="analyzer-tabs__button"
        type="button"
        role="tab"
        aria-selected={mode === 'photo'}
        aria-controls="photo-panel"
        tabIndex={mode === 'photo' ? 0 : -1}
        onClick={() => onChange('photo')}
      >
        <CameraIcon />
        Photo scan
      </button>
      <button
        id="manual-tab"
        className="analyzer-tabs__button"
        type="button"
        role="tab"
        aria-selected={mode === 'manual'}
        aria-controls="manual-panel"
        tabIndex={mode === 'manual' ? 0 : -1}
        onClick={() => onChange('manual')}
      >
        <RulerIcon />
        Manual measurements
      </button>
    </div>
  );
}
